module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-13-d19cf4e31d6717e30ae7601c6df4667d.webp";